export const accountWalkthroughKey = (userId: string) => `novari:walkthroughs-seen:${userId}`;
const memory = new Map<string, string[]>();
const listeners = new Map<string, Set<() => void>>();
export function subscribeAccountWalkthroughs(userId: string, listener: () => void) {
  const set = listeners.get(userId) ?? new Set();
  set.add(listener); listeners.set(userId, set);
  return () => { set.delete(listener); if (!set.size) listeners.delete(userId); };
}

export function readAccountWalkthroughs(userId: string): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(accountWalkthroughKey(userId)) || '[]');
    return [...new Set([...(Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : []), ...(memory.get(userId) || [])])];
  } catch { return memory.get(userId) || []; }
}

export function rememberAccountWalkthroughs(userId: string, ids: string[]) {
  const previous = JSON.stringify(readAccountWalkthroughs(userId));
  memory.set(userId, ids);
  try { localStorage.setItem(accountWalkthroughKey(userId), JSON.stringify(ids)); } catch { /* Memory still prevents repeats this session. */ }
  if (JSON.stringify(ids) !== previous) listeners.get(userId)?.forEach(listener => listener());
}

